import { useState, useEffect } from 'react';
import { Services } from 'services';
import { useAppSelector } from 'modules/state-mgmt/store';

interface Project {
  id: string;
  name: string;
}

export const useProjects = () => {
  const [projects, setProjects] = useState<Project[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const { workerId, languageCode } = useAppSelector(state => ({
    workerId: state.onboarding.id,
    languageCode: state.app?.languageCode,
  }));

  useEffect(() => {
    const loadProjects = async () => {
      if (!workerId) return;

      setIsLoading(true);
      setError(null);

      try {
        const response = await Services.getWorkerLiteProjects(
          workerId,
          1,
          undefined,
          undefined,
          undefined,
          languageCode || 'en',
          true, // clientSidePaging
        );

        if (response?.data?.items) {
          const projectList: Project[] = response.data.items.map((item: any) => ({
            id: item.project?.id || '',
            name: item.project?.name || '',
          }));
          setProjects(projectList);
        }
      } catch (err) {
        setError('Failed to load projects');
      } finally {
        setIsLoading(false);
      }
    };

    loadProjects();
  }, [workerId, languageCode]);

  return { projects, isLoading, error };
};
